module.exports = __webpack_public_path__ + "img/solomon-islands.d04556c8.png";